import React from "react";

import "./QrSessionExpiredPage.scss";

const QrSessionExpiredPage: React.FC = () => {
	return (
		<div className="QrSessionExpiredPage">
			<div className="QrSessionExpiredContent">
				<h1 className="QrSessionExpiredTitle">QR Code Expired</h1>
				<p className="QrSessionExpiredMessage">
					This QR code is no longer valid. Please scan a new QR code to continue.
				</p>
			</div>
		</div>
	);
};

export default QrSessionExpiredPage;
